import React from "react";
import { Colors } from "../../../../../shared/theme";
import { textStyles } from "../../../../../shared/theme/fonts-ppv";

export default {
  successSection: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: "12px",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  } as React.CSSProperties,
  successAnimation: {
    width: "147px",
    height: "150px",
  } as React.CSSProperties,
  sectionSuccessTitle: {
    ...textStyles.h2,
    color: Colors.grey800,
  } as React.CSSProperties,
  sectionSuccessSubTitle: {
    ...textStyles.subtitle1,
    color: Colors.grey600,
    marginTop: "18px",
    marginBottom: "18px",
  } as React.CSSProperties,
};
